import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type {
  SimulationRawResultsV2ListParams,
  SimulationRawResultsV2ListData,
  SimulationRawResultsV2FilterOptions,
} from '~/store/simulation/types';
import type {
  SimulationServiceV1SimulationRawResultsDetailData,
  SimulationServiceV1SimulationRawResultsFilterOptionsListData,
} from '@shipium-corp/shipium-ts-types';
import { V2_BASE } from './simulation';

// List summary. Strips undefined params so defaults on the server apply.
export const rawResultsListV2 = {
  queryKey: 'simulation-service/raw-results',
  configurationType: 'default' as const,
  fn: async (params: SimulationRawResultsV2ListParams): Promise<SimulationRawResultsV2ListData> => {
    const { simulationId, ...rest } = params;
    const query = Object.fromEntries(Object.entries(rest).filter(([, v]) => v !== undefined && v !== ''));
    const { data } = await GatewayAxiosClient.get<SimulationRawResultsV2ListData>(
      `${V2_BASE}/simulation/${simulationId}/raw-results`,
      { params: query },
    );
    return data;
  },
};

// Per-shipment detail. rawResult is an opaque bag (request/response/error/sellRates inside).
export const rawResultDetailV2 = {
  queryKey: 'simulation-service/raw-results/detail',
  configurationType: 'default' as const,
  fn: async (simulationId: string, historicalShipmentId: string): Promise<Record<string, unknown>> => {
    const { data } = await GatewayAxiosClient.get<SimulationServiceV1SimulationRawResultsDetailData>(
      `${V2_BASE}/simulation/${simulationId}/raw-results/${encodeURIComponent(historicalShipmentId)}`,
    );
    return data.rawResult;
  },
};

// Distinct facet values present in this simulation's raw results — drives the filter bar.
export const rawResultsFilterOptionsV2 = {
  queryKey: 'simulation-service/raw-results/filter-options',
  configurationType: 'cached' as const,
  fn: async (simulationId: string): Promise<SimulationRawResultsV2FilterOptions> => {
    const { data } = await GatewayAxiosClient.get<SimulationServiceV1SimulationRawResultsFilterOptionsListData>(
      `${V2_BASE}/simulation/${simulationId}/raw-results/filter-options`,
    );
    return data.filterOptions;
  },
};
